// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"58481eca","239":"7bdf461c","732":"79d91868"}[chunkId] + ".chunk.js";
};